module.exports = __webpack_public_path__ + "static/media/sanchezsemibold.ab76cad9.eot";